var _style, _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVvs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vvs_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 600 600",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".vvs_svg__st1{fill:#fff}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300.05,
    r: 300,
    fill: "#2c3851"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "vvs_svg__st1",
    d: "M300 474.12c-28.06 0-54.44-10.93-74.28-30.77l-77.62-77.61c-40.96-40.96-40.96-107.6 0-148.55l38.81-38.81c19.84-19.84 46.22-30.77 74.28-30.77h77.62c28.06 0 54.44 10.93 74.28 30.77l38.81 38.81c40.95 40.96 40.95 107.6 0 148.55l-77.62 77.61c-19.84 19.85-46.22 30.77-74.28 30.77zM261.19 189.3c-16.92 0-32.83 6.59-44.8 18.56l-38.81 38.81c-24.7 24.7-24.7 64.89 0 89.6l77.62 77.61c11.97 11.97 27.88 18.56 44.8 18.56 16.92 0 32.83-6.59 44.8-18.56l77.62-77.61c24.7-24.7 24.7-64.89 0-89.6l-38.81-38.81c-11.97-11.97-27.88-18.56-44.8-18.56h-77.62z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "vvs_svg__st1",
    d: "M300 418.28c-16.12 0-31.27-6.28-42.67-17.68l-64.62-64.62c-11.38-11.38-17.65-26.53-17.65-42.66s6.27-31.28 17.65-42.66l32.31-32.31c11.4-11.4 26.55-17.67 42.66-17.67h64.62c16.12 0 31.27 6.28 42.66 17.67l32.31 32.31c11.38 11.38 17.65 26.54 17.65 42.66s-6.27 31.28-17.65 42.66l-64.62 64.62c-11.38 11.4-26.53 17.68-42.65 17.68zm-32.31-176.33c-5.17 0-9.83 1.93-13.48 5.58l-32.31 32.31c-3.59 3.59-5.57 8.38-5.57 13.48s1.98 9.89 5.56 13.48l64.62 64.62c7.31 7.31 19.66 7.31 26.96 0l64.62-64.63c3.59-3.59 5.57-8.38 5.57-13.48 0-5.11-1.98-9.89-5.57-13.48l-32.31-32.31c-3.65-3.65-8.31-5.58-13.48-5.58h-64.61z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "vvs_svg__st1",
    d: "M300 367.04l-70.77-70.77 44.4-44.4h52.75l44.4 44.4z"
  })));
}

export default SvgVvs;